"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerFavoriteGamesListCtl = /** @class */ (function (_super) {
    __extends(PlayerFavoriteGamesListCtl, _super);
    function PlayerFavoriteGamesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_gws_gameprovider_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_id; });
        _this.dk_gws_gameprovider_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_title; });
        _this.dk_gws_gameprovider_game_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_id; });
        _this.dk_gws_gameprovider_game_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_game_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerFavoriteGamesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerFavoriteGamesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    PlayerFavoriteGamesListCtl.prototype.LoadData = function (playerId, onDone) {
        var _this = this;
        webAApi_1.ListUsrPlayerFavoriteGamesByUsrPlayerIdGet.exec({ user_player_id: playerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    gws_gameprovider_game_id: resp.list[i].gws_gameprovider_game_id,
                    gws_gameprovider_game_title: resp.list[i].gws_gameprovider_game_title,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerFavoriteGamesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddUsrPlayerFavoriteGame.exec({
            usr_player_id: data.usr_player_id,
            brand_id: data.brand_id,
            gws_gameprovider_id: data.gws_gameprovider_id,
            gws_gameprovider_game_id: data.gws_gameprovider_game_id
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_title: resp.gws_gameprovider_title,
                gws_gameprovider_game_id: data.gws_gameprovider_game_id,
                gws_gameprovider_game_title: resp.gws_gameprovider_game_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerFavoriteGamesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PlayerFavoriteGamesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteUserPlayerFavoriteGame.exec({
                usr_player_favorite_game_id: key,
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerFavoriteGamesListCtl;
}(BaseController_1.BaseController));
exports.PlayerFavoriteGamesListCtl = PlayerFavoriteGamesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerFavoriteGamesListCtl.ts
// module id = 936
// module chunks = 0